import { create } from "zustand";
import {
  Giveaway,
  GiveawayWUserPastEntries,
} from "../../../Common/models/giveaways";

interface SuperGiveAwayState {
  // timeRemaining: null | TimeRemaining;
  // setTimeRemaining: (state: null | TimeRemaining) => void;

  majorGiveawayList: null | Giveaway[];
  setMajorGiveawayList: (state: Giveaway[]) => void;

  cashGiveawayList: null | Giveaway[];
  setCashGiveawayList: (state: Giveaway[]) => void;

  majorAndSuperGiveawayList: null | Giveaway[];
  setMajorAndSuperGiveawayList: (state: Giveaway[]) => void;

  pastGiveawaysList: null | GiveawayWUserPastEntries[];
  setPastGiveawaysList: (state: GiveawayWUserPastEntries[]) => void;

  ongoingGiveaway: null | Giveaway;
  setOngoingGiveaway: (state: null | Giveaway) => void;

  upcomingGiveawayList: null | Giveaway[];
  setUpcomingGiveawayList: (state: Giveaway[]) => void;

  cancelView: boolean;
  setCancelView: (state: boolean) => void;

  resetStore: () => void;
}

const useSuperGiveAwayStore = create<SuperGiveAwayState>((set) => ({
  majorGiveawayList: null,
  setMajorGiveawayList: (giveAwayList) =>
    set({ majorGiveawayList: giveAwayList }),

  majorAndSuperGiveawayList: null,
  setMajorAndSuperGiveawayList: (giveAwayList) =>
    set({ majorAndSuperGiveawayList: giveAwayList }),

  cashGiveawayList: null,
  setCashGiveawayList: (giveAwayList) =>
    set({ cashGiveawayList: giveAwayList }),

  ongoingGiveaway: null,
  setOngoingGiveaway: (ongoingGiveaway) => set({ ongoingGiveaway }),

  upcomingGiveawayList: null,
  setUpcomingGiveawayList: (giveAwayList) =>
    set({ upcomingGiveawayList: giveAwayList }),

  pastGiveawaysList: null,
  setPastGiveawaysList: (giveAwayList) =>
    set({ pastGiveawaysList: giveAwayList }),

  cancelView: false,
  setCancelView: (cancelView) => set({ cancelView }),
  resetStore: () => {
    return set({
      majorGiveawayList: null,
      pastGiveawaysList: null,
      upcomingGiveawayList: null,
      cancelView: false,
    });
  },
}));

export default useSuperGiveAwayStore;
